<template>
	<div class="layout-profile">
		<div style="display:grid;margin-bottom:0.5em">
			<PictureBox :initial-image="commonService.getCDNImageUrl(authService.getUserAvatarUrl())" :imgWidth="125" :isEditable="false" :key="rerenderAvatar" :typeOfPicture="this.typeOfPicture " />
		</div>
		<button class="p-link layout-profile-link" @click="onClick">
			<span class="username">{{authService.getUserName()}}</span>
			<i class="pi pi-fw pi-cog"></i>
		</button>
		<transition name="layout-submenu-wrapper">
			<ul v-show="expanded">
				<li v-if="authService.getUserProfile() == $agentProfileId 
                       || authService.getUserProfile() == $coachingStaffProfileId
					   || authService.getUserProfile() == $teamProfileId
                       || authService.getUserProfile() == $playerProfileId">
					<button class="p-link">
						<i class="pi pi-fw pi-user"></i>
						<router-link to="/account">
							<span>{{$t('Account')}}</span>
						</router-link>
					</button>
				</li>
				<li>
					<button class="p-link" @click="logout">
						<i class="pi pi-fw pi-power-off"></i>
						<span>{{$t('Logout')}}</span>
					</button>
				</li>
			</ul>
		</transition>
	</div>
</template>

<script>
import PictureBox from "@/components/PictureBox";
import AuthService from "@/service/AuthService";
import CommonService from "@/service/CommonService";
import AgentService from "@/service/AgentService";
import Vue from "vue";

export default {
	components: {
		PictureBox,
	},
	data() {
		return {
			expanded: false,
			rerenderAvatar: 0,
			typeOfPicture: null,
		};
	},
	authService: null,
	commonService: null,
	created() {
		this.authService = new AuthService();
		this.commonService = new CommonService();
		this.agentService = new AgentService();

		switch (this.authService.getUserProfile()) {
			case Vue.prototype.$playerProfileId:
				this.typeOfPicture = "player";
				break;
			case Vue.prototype.$teamProfileId:
				this.typeOfPicture = "team";
				break;
			default:
			case Vue.prototype.$agentProfileId:
				this.typeOfPicture = "agent";
				break;
		}

		this.typeOfPicture = "player";
	},
	methods: {
		avatarChanged() {
			this.agentService.getAgentAvatar(this.authService.getUserId()).then(
				(res) => {
					this.authService.setUserAvatarUrl(res.data);
					this.rerenderAvatar += 1;
				},
				function (err) {}
			);
		},
		onClick(event) {
			this.expanded = !this.expanded;
			event.preventDefault();
		},
		logout() {
			this.authService.logout();
			this.$router.push("/home");
		},
	},
};
</script>

<style scoped>
</style>